import styled from "styled-components";
import {
  colors,
  radius,
  spacing,
  stroke,
  textStyles,
  toCSS
} from "design-system/foundation";
import { breakpoints } from "styles";

export const SubmissionContainer = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  align-self: center;
  width: 100%;
  flex-direction: column;
  gap: ${spacing["4xl"]};
  padding: ${spacing["2xl"]} ${spacing.none} ${spacing["2xl"]};
  border-radius: ${radius.xl};

  @media ${breakpoints.tablet} {
    width: min(800px, 100%);
    box-shadow: 0 8px 32px rgba(24, 27, 37, 0.15);
    background: ${colors.bg.base.default};
    padding: ${spacing["4xl"]};
  }
`;

export const SubmissionHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing["4xl"]};
  padding: ${spacing.none} ${spacing["2xl"]};
`;

export const HeaderTitle = styled.p`
  margin: ${spacing.none};
  flex: 1;
  ${toCSS(textStyles.heading.h5)}
`;

export const CloseButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${spacing.xs};

  .icon {
    display: flex;
    align-items: center;
    font-size: 20px;
    color: ${colors.icon.base.primary};
  }

  @media ${breakpoints.tablet} {
    display: flex;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${spacing["2xl"]};
  border-top: ${stroke.xs} solid ${colors.border.state.default};
  padding: ${spacing["2xl"]} ${spacing["2xl"]} ${spacing.none};

  > button {
    order: 2;
  }

  @media ${breakpoints.tablet} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing.md};
    border-top: none;
    padding: ${spacing.none};
  }
`;

export const RightButton = styled.div`
  display: flex;
  flex-direction: column;
  order: 1;
  gap: ${spacing["2xl"]};

  button:last-child {
    order: -1;
  }

  @media ${breakpoints.tablet} {
    flex-direction: row;
    order: 2;
  }
`;
